var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9869 7.87085C13.9621 7.74729 13.9027 7.63333 13.8156 7.5423C13.7285 7.45127 13.6172 7.38695 13.4949 7.35685L8.92153 6.21285L10.6129 2.26551C10.6718 2.12853 10.683 1.97573 10.6447 1.83163C10.6063 1.68752 10.5207 1.56046 10.4015 1.47085C10.2826 1.38064 10.1367 1.33316 9.98742 1.33606C9.83816 1.33897 9.69423 1.39209 9.57886 1.48685L2.24553 7.48685C2.14988 7.5651 2.07785 7.66839 2.03751 7.7852C1.99716 7.90202 1.99008 8.02774 2.01705 8.14835C2.04402 8.26895 2.10398 8.37969 2.19024 8.46818C2.2765 8.55668 2.38566 8.61946 2.50553 8.64951L6.98487 9.77018L4.75487 13.6728C4.69734 13.7742 4.66737 13.8889 4.66795 14.0055C4.66852 14.1221 4.69963 14.2364 4.75816 14.3373C4.81669 14.4381 4.90061 14.5218 5.00156 14.5801C5.1025 14.6384 5.21696 14.6692 5.33353 14.6695C5.47782 14.6698 5.61825 14.6229 5.73353 14.5362L13.7335 8.53618C13.8343 8.46056 13.9116 8.35792 13.9564 8.24016C14.0013 8.12241 14.0118 7.99435 13.9869 7.87085Z",
    fill: "#A80101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapSvgrepoCom1);
export default __webpack_public_path__ + "static/media/zap-svgrepo-com 1.acd8f37d3ae4b2229a3d581b5abfaaa5.svg";
export { ForwardRef as ReactComponent };